import { assert } from '@varos/util-typescript';
import { ReportingLoaderBaseConfig } from '../../base';
import { DatabaseBlockLoader } from './databaseViewBlockInterface';
import { DatabaseBlockAggregate } from './databaseViewBlockModel';
import { CollectionLoader } from '../../page/common/collection';

export function createDatabaseBlockLoader(
    config: ReportingLoaderBaseConfig & {
        collection: {
            loader: CollectionLoader;
        };
    }
): DatabaseBlockLoader {
    const {
        repository: { research },
    } = config;
    const collectionLoader = config.collection.loader;

    return {
        useLoad(context, props): DatabaseBlockAggregate {
            const blockQuery = research.block.useLookup(
                context,
                {
                    id: props.block,
                },
                {
                    suspense: true,
                }
            );

            assert(blockQuery.status === 'success', 'expected suspense');
            assert(
                blockQuery.data.data.kind === 'database_view',
                'expected database block'
            );

            // Use shared collection loader
            const collectionData = collectionLoader.useLoad(context, {
                collection: blockQuery.data.data.collection,
            });

            return {
                block: blockQuery.data,
                database: blockQuery.data.data,
                ...collectionData,
                collectionAggregate: collectionData,
                content: collectionData.record,
            };
        },
    };
}
